// ── 1 Kunde ── das Formular.

import { post } from "../../api/client";
import type { ProbeResult, Tenant } from "../../api/types";
import { Field, Input } from "../../ui/field";
import { normalizeSlug, type CustomerState } from "./customer";
import { Probe } from "./probe";
import { fieldError, setter } from "./shared";
import type { StepFormProps } from "./types";

export function CustomerForm({ tenant: t, catalog, state, setState, check }: StepFormProps<CustomerState, Tenant | null>) {
  const set = setter(setState);
  // Nach der Einrichtung hängen Datenbank, Container, DNS und Zertifikat am Slug.
  const locked = Boolean(t && t.state !== "draft");
  const err = (k: string) => fieldError(check, k);
  return (
    <>
      <div className="pf-grid">
        <Field label="Name des Kunden" error={err("name")}>
          <Input name="name" value={state.name} invalid={!!err("name")} onChange={(e) => set("name")(e.target.value)} />
        </Field>
        <Field
          label="Slug" error={err("slug")}
          hint={locked
            ? "Nach der Einrichtung nicht mehr änderbar — Datenbank, Container, DNS und Zertifikat hängen daran."
            : <>wird zu <code>{normalizeSlug(state.slug) || "slug"}.{catalog.root_domain}</code></>}
        >
          <Input name="slug" value={state.slug} readOnly={locked} invalid={!!err("slug")} autoComplete="off" spellCheck={false} onChange={(e) => set("slug")(e.target.value)} />
        </Field>
        <Field label="Ansprechpartner">
          <Input name="contact_name" value={state.contact_name} onChange={(e) => set("contact_name")(e.target.value)} />
        </Field>
        <Field label="E-Mail des Ansprechpartners" error={err("contact_email")}>
          <Input name="contact_email" type="email" value={state.contact_email} invalid={!!err("contact_email")} onChange={(e) => set("contact_email")(e.target.value)} />
        </Field>
      </div>
      {t && !locked && (
        <Probe label="Slug im DNS prüfen" outId="probe-slug" run={() => post<ProbeResult>(`/tenants/${t.id}/checks/slug`, { slug: normalizeSlug(state.slug) })} />
      )}
    </>
  );
}
